(function () {
  if (document.documentElement.dir !== 'rtl') return;

  function moveChatLeft() {
    const el = document.querySelector('inbox-online-store-chat#ShopifyChat') || document.querySelector('inbox-online-store-chat');

    if (!el) return;

    el.setAttribute('button-position', 'bottom_left');
    el.setAttribute('button-vertical-position', 'lowest');

    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('left', '16px', 'important');
    el.style.setProperty('bottom', '16px', 'important');
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('z-index', '2147483647', 'important');
  }

  // 少し遅延してから一度だけ実行（アプリ読み込み待ち）
  window.addEventListener('load', () => {
    setTimeout(moveChatLeft, 1000);
  });
})();
